import { Service } from "../decorators/service.decorator";
import { ApiService } from "./ApiService";

@Service()
export class SearchService {

    _basePath;
    _apiService;
    _params;

    constructor() {
        this._basePath = 'search';
        this._apiService = new ApiService();
    }

    search(language, searchPhrase) {
        this._params = {
            language: language,
            searchPhrase: searchPhrase
        };
        return this._apiService.get(this._basePath, {params: this._params});
    }
}
